export const DEFAULT_IMAGE_ICON_SIZE = 33;

export const DEFAULT_IMAGE_SIZE = 60;

export const NUMBER_OF_OPTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const NUMBER_OF_PROJECTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const MAX_DESCRIPTION_LINE_LENGTH = 500;
export const MAX_MODIFIER_LENGTH = 485;
export const UPDATE_BILLING_ADDRESS_DEBOUNCE_MS = 400;
export const MAX_GIFT_CARDS = 5;

/** @deprecated */
export const petriSpecs = {
  CheckoutExcludeGoogleAutoComplete: 'specs.ecom.CheckoutExcludeGoogleAutoComplete',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  AlwaysSendCurrencyHeader: 'specs.ecom.AlwaysSendCurrencyHeader',
  SupportManualPaymentsOnPaymentRequest: 'specs.ecom.SupportManualPaymentsOnPaymentRequest',
  ShowVoidedErrorMessage: 'specs.ecom.ShowVoidedErrorMessage',
  HideMissingLineItemImagesInPaymentRequest: 'specs.ecom.HideMissingLineItemImagesInPaymentRequest',
  ErrorHandlerOnStorefrontSdk: 'specs.ecom.ErrorHandlerOnStorefrontSdk',
  AddCartServiceToContext: 'specs.ecom.AddCartServiceToContext',
  ExpressLoaderInCheckout: 'specs.ecom.ExpressLoaderInCheckout',
  DeliveryOptionsSetFirstAsDefault: 'specs.ecom.deliveryOptionsSetFirstAsDefault',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  RegisterWebMcpTools: 'specs.ecom.RegisterWebMcpTools',
  ShowAllSubscriptionItemNames: 'specs.ecom.ShowAllSubscriptionItemNames',
  UpdateCartOnBillingFieldsChange: 'specs.ecom.UpdateCartOnBillingFieldsChange',
  UpdateCartOnCustomerFieldsChange: 'specs.ecom.UpdateCartOnCustomerFieldsChange',
  PaymentErrorNoCountryHandling: 'specs.ecom.paymentErrorNoCountryHandling',
  MoveShippingDiscountUnderDelivery: 'specs.ecom.MoveShippingDiscountUnderDelivery',
  SecondaryTitleOnlyInTotalsRow: 'specs.ecom.SecondaryTitleOnlyInTotalsRow',
  SupportMultipleGCInCheckout: 'specs.ecom.SupportMultipleGCInCheckout',
  CheckoutNewPhoneAndFullNameFields: 'specs.ecom.CheckoutNewPhoneAndFullNameFields',
  FullNameLeafOverrides: 'specs.ecom.FullNameLeafOverrides',
  EnableBuilderContextProvider: 'specs.ecom.EnableBuilderContextProvider',
  SupportSkipCheckout: 'specs.ecom.SupportSkipCheckout',
  FixZoomCheckoutPolicesA11y: 'specs.ecom.FixZoomCheckoutPolicesA11y',
  HandleMembershipCalculationError: 'specs.ecom.HandleMembershipCalculationError',
};

export const conductorSpecs = {
  ecomCartValidationsInPurchaseFlow: 'ecomCartValidationsInPurchaseFlow',
  ecomCheckoutComposerViewer: 'ecomCheckoutComposerViewer',
  ecomCheckoutBrandStyling: 'ecomCheckoutBrandStyling',
  StopSupportingOldPlaceOrderErrorCodes: 'StopSupportingOldPlaceOrderErrorCodes',
  ecomRefactorMemberAddressFormInit: 'ecomRefactorMemberAddressFormInit',
  ecomUseMembershipOverSelectedMembership: 'ecomUseMembershipOverSelectedMembership',
  ecomAddPhoneToMarketingConsent: 'ecomAddPhoneToMarketingConsent',
  ecomShowReducedDiscountAmount: 'ecomShowReducedDiscountAmount',
  ecomShowTotalSavings: 'ecomShowTotalSavings',
  ecomShowSubdivisionSelectorWithSelectedMethod: 'ecomShowSubdivisionSelectorWithSelectedMethod',
};

export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs,
};

export const A11yIds = {
  SummarySection: 'summary-section',
};

export const MANDATORY_FIELDS_HIDDEN = [
  'countryCode',
  'state',
  'email',
  'firstName',
  'lastName',
  'street',
  'houseNumber',
  'address',
  'city',
  'zipCode',
  'phone',
];

export const HOLDER_ID_FIELD = 'holderId';
export const POLICIES_PATH = 'policies';
